import React, { useRef } from "react";
import "./About.scss";
// import deadstar from "../res/deadstar.png";
import useOnScreen from "../hooks/intersecting";

export default function About() {
  const ref = useRef();
  const isVisible = useOnScreen(ref);

  return (
    <section ref={ref} className={`about ${isVisible ? "reveal" : ""}`}>
      <div className="cont">
        {/* <div
          id="aboutme"
          className="secret-photo"
          style={{ backgroundImage: `url(${deadstar})` }}></div> */}

        <div className="infoCont">
          {/* <div className="box"></div> */}

          <div className="info">
            Hi, I am <b>deadstar</b>. I am currently trying to live life and 2-3
            year Dagestan.
            <br />
            <br />
            I love Judo, BJJ, boxing, calisthenics, running long distances, road
            cycling, adventure touring, and mountain biking.
            <br />
            <br />I live my life to the fullest.
          </div>
        </div>
      </div>
    </section>
  );
}
